import { render } from "./ProductDetails.vue?vue&type=template&id=d3e7fbcc&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=d3e7fbcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d3e7fbcc"

export default script